import { useEffect } from "react"
import { setExperimentVariant } from "~/common/analytics"
import { getMetaContentMaybe } from "~/common/get-meta-content"

export const useHostLinks = () => {
  const variant = getMetaContentMaybe("sharepage-host-links-variant")
  useEffect(() => setExperimentVariant("exp_sharepage_host_links_variant", variant), [variant])

  return variant === "links"
}
